import { InputFilterTrigger } from '@src/shared/features/views/components/static-filter-inputs';
import { programStatusFilterConfig } from '../../../configs/program-status-filter-config';

export const ProgramStatusFilter = () => {
  return (
    <InputFilterTrigger
      filterLabel='Status'
      config={programStatusFilterConfig}
    />
  );
};
